<template>
  <div class="financial-statement-item">
    <col-table :data="financeData" :pageSize="pageSize" :class="{ 'col-table--same': isSame, 'table-var': true }">
      <col-table-column label="日期" prop="endDate" :css="{ height: '50px' }">
        <template #header>
          <div class="date-header">
            <span>报告期<i class="iconfont icon-wenhao ml-4px" @click="popupVisible = true"></i></span>
            <span class="tongbi">
              {{ $t('同比')
              }}<span class="checkbox-wrap"><input type="checkbox" v-model="isSame" class="checkbox" /></span>
            </span>
          </div>
        </template>
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ scope.row.sortYear + scope.row.reportType }}</span>
            <span class="scale">{{ $t('同比') }}</span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="endDate" label="报表截止日" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          {{ $digitjs(scope.row.endDate).isNull() }}
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>经营活动</template>
      </col-table-column>
      <col-table-column prop="operatingNetIncome" label="持续经营净收入">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.operatingNetIncome).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.operatingNetIncomeYoY).color() }" class="scale">
              {{ $digitjs(scope.row.operatingNetIncomeYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="depreciationAndAmortization" label="折旧及摊销">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.depreciationAndAmortization).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.depreciationAndAmortizationYoY).color() }" class="scale">
              {{ $digitjs(scope.row.depreciationAndAmortizationYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="stockBasedCompensation" label="基于股票的补偿费">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.stockBasedCompensation).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.stockBasedCompensationYoY).color() }" class="scale">
              {{ $digitjs(scope.row.stockBasedCompensationYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="impairment" label="减值及拨备">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.impairment).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.impairmentYoY).color() }" class="scale">
              {{ $digitjs(scope.row.impairmentYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="deferredTax" label="递延所得税">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.deferredTax).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.deferredTaxYoY).color() }" class="scale">
              {{ $digitjs(scope.row.deferredTaxYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netIncomeFromDisposalAssets" label="资产处置损益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.netIncomeFromDisposalAssets).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.netIncomeFromDisposalAssetsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.netIncomeFromDisposalAssetsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="profitAndLossOnInvestments" label="投资损益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.profitAndLossOnInvestments).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.profitAndLossOnInvestmentsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.profitAndLossOnInvestmentsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="exchangeGainsOrLosses" label="汇兑损益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.exchangeGainsOrLosses).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.exchangeGainsOrLossesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.exchangeGainsOrLossesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="profitAndLossOnEquityInvestment" label="权益性投资损益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.profitAndLossOnEquityInvestment).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.profitAndLossOnEquityInvestmentYoY).color() }" class="scale">
              {{ $digitjs(scope.row.profitAndLossOnEquityInvestmentYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherItemsOfBusinessAdjustment" label="经营业务调整其他项目">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.otherItemsOfBusinessAdjustment).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.otherItemsOfBusinessAdjustmentYoY).color() }" class="scale">
              {{ $digitjs(scope.row.otherItemsOfBusinessAdjustmentYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="accountsAndNotesReceivable" label="应收账款及票据">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.accountsAndNotesReceivable).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.accountsAndNotesReceivableYoY).color() }" class="scale">
              {{ $digitjs(scope.row.accountsAndNotesReceivableYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="relatedPartiesReceivable" label="应收关联方款项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.relatedPartiesReceivable).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.relatedPartiesReceivableYoY).color() }" class="scale">
              {{ $digitjs(scope.row.relatedPartiesReceivableYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="goodsInStock" label="存货变化">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.goodsInStock).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.goodsInStockYoY).color() }" class="scale">
              {{ $digitjs(scope.row.goodsInStockYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="advanceForExpenses" label="预付费用">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.advanceForExpenses).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.advanceForExpensesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.advanceForExpensesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="relatedPartiesPayable" label="应付关联方款项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.relatedPartiesPayable).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.relatedPartiesPayableYoY).color() }" class="scale">
              {{ $digitjs(scope.row.relatedPartiesPayableYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="accountsAndNotesPayable" label="应付账款及票据">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.accountsAndNotesPayable).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.accountsAndNotesPayableYoY).color() }" class="scale">
              {{ $digitjs(scope.row.accountsAndNotesPayableYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="taxPayable" label="应付税项">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.taxPayable).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.taxPayableYoY).color() }" class="scale">
              {{ $digitjs(scope.row.taxPayableYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="accruedExpenses" label="预提费用及其他负债">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.accruedExpenses).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.accruedExpensesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.accruedExpensesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherOperatingBusiness" label="经营业务其他项目">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.otherOperatingBusiness).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.otherOperatingBusinessYoY).color() }" class="scale">
              {{ $digitjs(scope.row.otherOperatingBusinessYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherCurrentAssets" label="其他流动资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.otherCurrentAssets).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.otherCurrentAssetsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.otherCurrentAssetsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column
        prop="netCFFO"
        label="经营活动产生的现金流量净额"
        :css="{ ...mainDataStyle, marginBottom: '17px' }"
      >
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.netCFFO).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.netCFFOYoY).color() }" class="scale">
              {{ $digitjs(scope.row.netCFFOYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>投资活动</template>
      </col-table-column>
      <col-table-column prop="deposit" label="存款增加(减少)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.deposit).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.depositYoY).color() }" class="scale">
              {{ $digitjs(scope.row.depositYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="purchaseOfFixedAssets" label="购买固定资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.purchaseOfFixedAssets).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.purchaseOfFixedAssetsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.purchaseOfFixedAssetsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="disposalOfFixedAssets" label="处置固定资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.disposalOfFixedAssets).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.disposalOfFixedAssetsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.disposalOfFixedAssetsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="purchaseOfIntangibleAsset" label="购建无形资产及其他资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.purchaseOfIntangibleAsset).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.purchaseOfIntangibleAssetYoY).color() }" class="scale">
              {{ $digitjs(scope.row.purchaseOfIntangibleAssetYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="disposalOfIntangibleAsset" label="处置无形资产及其他资产">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.disposalOfIntangibleAsset).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.disposalOfIntangibleAssetYoY).color() }" class="scale">
              {{ $digitjs(scope.row.disposalOfIntangibleAssetYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="cashPaidForInvestment" label="投资支付现金">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.cashPaidForInvestment).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.cashPaidForInvestmentYoY).color() }" class="scale">
              {{ $digitjs(scope.row.cashPaidForInvestmentYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="thePaymentOfDebt" label="债务偿还">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.thePaymentOfDebt).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.thePaymentOfDebtYoY).color() }" class="scale">
              {{ $digitjs(scope.row.thePaymentOfDebtYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherInvestmentBusiness" label="投资业务其他项目">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.otherInvestmentBusiness).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.otherInvestmentBusinessYoY).color() }" class="scale">
              {{ $digitjs(scope.row.otherInvestmentBusinessYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column
        prop="netCFFI"
        label="投资活动产生的现金流量净额"
        :css="{ ...mainDataStyle, marginBottom: '17px' }"
      >
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.netCFFI).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.netCFFIYoY).color() }" class="scale">
              {{ $digitjs(scope.row.netCFFIYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column :css="css">
        <template #header>筹资活动</template>
      </col-table-column>
      <col-table-column prop="issuedShares" label="发行股份">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.issuedShares).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.issuedSharesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.issuedSharesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="issuedBonds" label="发行债券">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.issuedBonds).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.issuedBondsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.issuedBondsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="disbursementOfDividends" label="股息支付">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.disbursementOfDividends).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.disbursementOfDividendsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.disbursementOfDividendsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="incomeFromStockOptions" label="行使股票期权所得">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.incomeFromStockOptions).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.incomeFromStockOptionsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.incomeFromStockOptionsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="newBorrowings" label="新增借款">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.newBorrowings).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.newBorrowingsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.newBorrowingsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="cashAndEquity" label="现金及权益增加(减少)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.cashAndEquity).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.cashAndEquityYoY).color() }" class="scale">
              {{ $digitjs(scope.row.cashAndEquityYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="paymentsOnBehalf" label="垫款增加(减少)">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.paymentsOnBehalf).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.paymentsOnBehalfYoY).color() }" class="scale">
              {{ $digitjs(scope.row.paymentsOnBehalfYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="repaymentsOfBorrowings" label="偿还借款">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.repaymentsOfBorrowings).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.repaymentsOfBorrowingsYoY).color() }" class="scale">
              {{ $digitjs(scope.row.repaymentsOfBorrowingsYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="interestOnIndebtedness" label="贷款收益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.interestOnIndebtedness).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.interestOnIndebtednessYoY).color() }" class="scale">
              {{ $digitjs(scope.row.interestOnIndebtednessYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="floatationCost" label="发行费用相关">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.floatationCost).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.floatationCostYoY).color() }" class="scale">
              {{ $digitjs(scope.row.floatationCostYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="incomeOfNotes" label="票据相关收益">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.incomeOfNotes).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.incomeOfNotesYoY).color() }" class="scale">
              {{ $digitjs(scope.row.incomeOfNotesYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="otherFinancingBusiness" label="筹资业务其他项目">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.otherFinancingBusiness).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.otherFinancingBusinessYoY).color() }" class="scale">
              {{ $digitjs(scope.row.otherFinancingBusinessYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column
        prop="netCFFF"
        label="筹资活动产生的现金流量净额"
        :css="{ ...mainDataStyle, marginBottom: '17px' }"
      >
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.netCFFF).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.netCFFFYoY).color() }" class="scale">
              {{ $digitjs(scope.row.netCFFFYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column
        prop="effectOfForeignCurrencyTranslation"
        label="汇率变动影响"
        :css="{ ...mainDataStyle, marginBottom: '17px' }"
      >
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.effectOfForeignCurrencyTranslation).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.effectOfForeignCurrencyTranslationYoY).color() }" class="scale">
              {{ $digitjs(scope.row.effectOfForeignCurrencyTranslationYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="netIncreaseInCash" label="现金流净增加额" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.netIncreaseInCash).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.netIncreaseInCashYoY).color() }" class="scale">
              {{ $digitjs(scope.row.netIncreaseInCashYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="cashFlowAtBeginning" label="期初现金流" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.cashFlowAtBeginning).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.cashFlowAtBeginningYoY).color() }" class="scale">
              {{ $digitjs(scope.row.cashFlowAtBeginningYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="cashFlowAtEnd" label="期末现金流" :css="mainDataStyle">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.cashFlowAtEnd).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.cashFlowAtEndYoY).color() }" class="scale">
              {{ $digitjs(scope.row.cashFlowAtEndYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="freeCashFlow" label="自由现金流" :css="{ ...mainDataStyle, marginBottom: '17px' }">
        <template slot-scope="scope">
          <div class="value-wrap">
            <span class="value">{{ $digitjs(scope.row.freeCashFlow).convert() }}</span>
            <span :style="{ color: $digitjs(scope.row.freeCashFlowYoY).color() }" class="scale">
              {{ $digitjs(scope.row.freeCashFlowYoY).prefix().unit('%').rounded() }}
            </span>
          </div>
        </template>
      </col-table-column>
      <col-table-column prop="accountingStandard" label="会计准则">
        <template slot-scope="scope">
          {{ $digitjs(scope.row.accountingStandard).isNull() }}
        </template>
      </col-table-column>
      <col-table-column prop="balanceSheetDate" label="年结日">
        <template slot-scope="scope">
          {{ $digitjs(scope.row.balanceSheetDate).isNull() }}
        </template>
      </col-table-column>
      <col-table-column prop="reportDate" label="公布日期" :css="{ marginBottom: '17px' }">
        <template slot-scope="scope">
          {{ $digitjs(scope.row.reportDate).isNull() }}
        </template>
      </col-table-column>
    </col-table>
    <RkPopup :visible.sync="popupVisible"><ReportSheetPrompt /></RkPopup>
  </div>
</template>

<script>
import RkPopup from '@/components/common/Popup.vue'
import ReportSheetPrompt from '@/components/common/ReportSheetPrompt.vue'
export default {
  components: { RkPopup, ReportSheetPrompt },
  props: ['css', 'mainDataStyle'],
  data() {
    return {
      isSame: false,
      popupVisible: false,
      financeData: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    pageSize() {
      return this.isSame ? 1 : 2
    }
  },
  created() {
    this.getIncomeStatement()
  },
  methods: {
    async getIncomeStatement() {
      const res = await this.$post(this.$api.f10.us + '/finance/cash-basic', {
        symbol: this.symbol,
        reportSize: 20,
        reportTypes: ['FY', 'Q4', 'Q9', 'Q3', 'Q6', 'Q2', 'Q1']
      })
      const reportTypeMap = {
        FY: 7,
        Q4: 6,
        Q9: 5,
        Q3: 4,
        Q6: 3,
        Q2: 2,
        Q1: 1
      }
      const data =
        res.data?.map((item) => {
          const { endDate, balanceSheetDate } = item
          const year = this.$dayjs(endDate).format('YYYY')
          const isBefore = this.$dayjs(year + '/' + balanceSheetDate).isBefore(this.$dayjs(endDate))
          item.sortYear = isBefore ? +year + 1 : +year
          return item
        }) ?? []
      this.financeData = data.sort(
        (a, b) => b.sortYear - a.sortYear || reportTypeMap[b.reportType] - reportTypeMap[a.reportType]
      )
    }
  }
}
</script>

<style lang="scss" scoped></style>
